'use client'

import { type PropsWithChildren } from 'react'

import { ThemeProvider } from 'next-themes'

import { QueryClientProvider } from '@tanstack/react-query'
import { NuqsAdapter } from 'nuqs/adapters/next/app'

import { getQueryClient } from '@/lib/react-query'

import { Toaster } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'

import SettingsProvider from '@/store/settings/context'

export default function Providers({ children }: PropsWithChildren) {
  const queryClient = getQueryClient()
  return (
    <QueryClientProvider client={queryClient}>
      <NuqsAdapter>
        <SettingsProvider>
          <ThemeProvider
            attribute="class"
            defaultTheme="light"
            enableSystem={false}
            disableTransitionOnChange
          >
            <TooltipProvider>
              {children}

              <Toaster position="top-right" richColors expand={true} />
            </TooltipProvider>
          </ThemeProvider>
        </SettingsProvider>
      </NuqsAdapter>
    </QueryClientProvider>
  )
}
